/**
 * ✅ UTILITÁRIO COMPARTILHADO: Normalização de campos de contato seguindo padrão Baileys
 * 
 * REGRAS DO BAILEYS:
 * - remoteJid = "{numero}@s.whatsapp.net" → number = parte antes do @
 * - remoteJid = "{lid}@lid" → lid = parte antes do @
 * 
 * Esta função extrai valores do remoteJid para preencher number/lid quando vazios,
 * mas NÃO move valores arbitrariamente entre campos.
 * 
 * @param {Object} contactData - Dados do contato com campos number, lid, remoteJid
 * @returns {Object} - Dados normalizados
 */
export const normalizeContactFields = (contactData) => {
	if (!contactData) return contactData;

	const normalized = { ...contactData };
	let numberValue = String(normalized.number || '').trim();
	let lidValue = String(normalized.lid || '').trim();
	let remoteJidValue = String(normalized.remoteJid || '').trim();

	// ✅ CORREÇÃO: Extrair valores do remoteJid seguindo padrão Baileys
	if (remoteJidValue) {
		const [userPart, server] = remoteJidValue.split('@');
		
		if (server === 's.whatsapp.net') {
			// Se remoteJid é @s.whatsapp.net, extrair número de telefone
			const phoneFromJid = userPart.trim();
			// Preencher number apenas se estiver vazio e o valor extraído for válido
			if (!numberValue && phoneFromJid && /^\d+$/.test(phoneFromJid)) {
				numberValue = phoneFromJid;
			}
		} else if (server === 'lid') {
			// Se remoteJid é @lid, extrair LID
			const lidFromJid = userPart.trim();
			// Preencher lid apenas se estiver vazio e o valor extraído for válido
			if (!lidValue && lidFromJid && /^\d+$/.test(lidFromJid)) {
				lidValue = lidFromJid;
			}
		}
	}

	// Limpar apenas espaços e caracteres especiais do number (se for número válido)
	if (numberValue) {
		const cleanNumber = numberValue.replace(/[\s\-\(\)]/g, '');
		// Se após limpar ainda é um número válido (apenas dígitos), usar valor limpo
		if (/^\d+$/.test(cleanNumber)) {
			numberValue = cleanNumber;
		}
		// Se não é número válido, manter como está (pode ser formato especial)
	}

	// Limpar apenas espaços do lid (deve ser apenas dígitos)
	if (lidValue) {
		const cleanLid = lidValue.replace(/[\s\-\(\)]/g, '').replace(/@lid$/, '');
		if (/^\d+$/.test(cleanLid)) {
			lidValue = cleanLid;
		}
	}

	normalized.number = numberValue;
	normalized.lid = lidValue;
	normalized.remoteJid = remoteJidValue;

	return normalized;
};
